import {fetchDepartments, fetchProducts, fetchProductDetails,getBestSeller,getNewArrivals, getSpecials, getSearchResults,getFeaturedProducts, getFilters, getSearchFilters} from '../services/products';
import * as ProductHelpers from '../utils/productHelpers';

export const GET_DEPARTMENTS_REQUEST = 'GET_DEPARTMENTS_REQUEST';
export const GET_DEPARTMENTS_SUCCESS = 'GET_DEPARTMENTS_SUCCESS';
export const GET_DEPARTMENTS_FAILURE = 'GET_DEPARTMENTS_FAILURE';
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILURE = 'GET_PRODUCTS_FAILURE';
export const GET_PRODUCT_DETAILS_REQUEST = 'GET_PRODUCT_DETAILS_REQUEST';
export const GET_PRODUCT_DETAILS_SUCCESS = 'GET_PRODUCT_DETAILS_SUCCESS';
export const GET_PRODUCT_DETAILS_FAILURE = 'GET_PRODUCT_DETAILS_FAILURE';
export const GET_BEST_SELLER_REQUEST = 'GET_BEST_SELLER_REQUEST';
export const GET_BEST_SELLER_SUCCESS = 'GET_BEST_SELLER_SUCCESS';
export const GET_BEST_SELLER_FAILURE = 'GET_BEST_SELLER_FAILURE';
export const GET_NEW_ARRIVAL_REQUEST = 'GET_NEW_ARRIVAL_REQUEST';
export const GET_NEW_ARRIVAL_SUCCESS = 'GET_NEW_ARRIVAL_SUCCESS';
export const GET_NEW_ARRIVAL_FAILURE = 'GET_NEW_ARRIVAL_FAILURE';
export const GET_SEARCH_REQUEST = 'GET_SEARCH_REQUEST';
export const GET_SEARCH_SUCCESS = 'GET_SEARCH_SUCCESS';
export const GET_SEARCH_FAILURE = 'GET_SEARCH_FAILURE';
export const GET_FEATURED_REQUEST = 'GET_FEATURED_REQUEST';
export const GET_FEATURED_SUCCESS = 'GET_FEATURED_SUCCESS';
export const GET_FEATURED_FAILURE = 'GET_FEATURED_FAILURE';
export const GET_PRODUCT_FILTERS_REQUEST = 'GET_PRODUCT_FILTERS_REQUEST';
export const GET_PRODUCT_FILTERS_SUCCESS = 'GET_PRODUCT_FILTERS_SUCCESS';
export const GET_PRODUCT_FILTERS_FAILURE = 'GET_PRODUCT_FILTERS_FAILURE';
export const SET_SIMILAR_PEODUCTS = 'SET_SIMILAR_PEODUCTS';
export const SET_LIST_PAGE_STATE = 'SET_LIST_PAGE_STATE';
export const SET_SEARCH_RESULT_LIST_PAGE_STATE = 'SET_SEARCH_RESULT_LIST_PAGE_STATE';
export const GET_PRODUCT_SEARCH_FILTERS_REQUEST = 'GET_PRODUCT_SEARCH_FILTERS_REQUEST';
export const GET_PRODUCT_SEARCH_FILTERS_SUCCESS = 'GET_PRODUCT_SEARCH_FILTERS_SUCCESS';
export const GET_PRODUCT_SEARCH_FILTERS_FAILURE = 'GET_PRODUCT_SEARCH_FILTERS_FAILURE';
export const GET_SPECIALS_REQUEST = 'GET_SPECIALS_REQUEST';
export const GET_SPECIALS_SUCCESS = 'GET_SPECIALS_SUCCESS';
export const GET_SPECIALS_FAILURE = 'GET_SPECIALS_FAILURE';

export function getDepartments() {
  return dispatch => {
    dispatch({type: GET_DEPARTMENTS_REQUEST})
    return fetchDepartments().then(res => {
      dispatch({type: GET_DEPARTMENTS_SUCCESS, payload: res})
    }).catch(err => {
      dispatch({type: GET_DEPARTMENTS_FAILURE, payload: err})
    });
  };
}

export function getProducts(params, callback) {

  return dispatch => {
    dispatch({type: GET_PRODUCTS_REQUEST})
    return fetchProducts(params).then(res => {
      dispatch({type: GET_PRODUCTS_SUCCESS, payload: res})
      if (callback) {
        callback({status: true, data: res})
      }
    }).catch(err => {
      dispatch({type: GET_PRODUCTS_FAILURE, payload: err})
      if (callback) {
        callback({status: false, data: err})
      }
    });
  };
}

export function getAllWines(params, callback) {

  return dispatch => {
    dispatch({type: GET_PRODUCTS_REQUEST})
    return getFeaturedProducts('WINES', params).then(res => {
      dispatch({type: GET_PRODUCTS_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_PRODUCTS_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function getProductDetails(productId, callback) {
  return dispatch => {
    dispatch({type: GET_PRODUCT_DETAILS_REQUEST})
    return fetchProductDetails(productId).then(res => {
      dispatch({type: GET_PRODUCT_DETAILS_SUCCESS, payload: res});
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_PRODUCT_DETAILS_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err});
      }
    });
  };
}

export function getBestSellerProducts(params,callback) {

  return dispatch => {
    dispatch({type: GET_BEST_SELLER_REQUEST})
    return getBestSeller(params).then(res => {
      dispatch({type: GET_BEST_SELLER_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_BEST_SELLER_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function getSpecialProducts(params,callback) {

  return dispatch => {
    dispatch({type: GET_SPECIALS_REQUEST})
    return getSpecials(params).then(res => {
      dispatch({type: GET_SPECIALS_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_SPECIALS_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}
export function getNewArrivalProducts(params,callback) {

  return dispatch => {
    dispatch({type: GET_NEW_ARRIVAL_REQUEST})
    return getNewArrivals(params).then(res => {
      dispatch({type: GET_NEW_ARRIVAL_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_NEW_ARRIVAL_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}


export function getSearchResultProducts(params,callback) {
  return dispatch => {
    dispatch({type: GET_SEARCH_REQUEST})
    return getSearchResults(params).then(res => {
      dispatch({type: GET_SEARCH_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_SEARCH_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function fetchFeaturedProducts(department,callback) {
  return dispatch => {
    dispatch({type: GET_FEATURED_REQUEST})
    return getFeaturedProducts(department).then(res => {
      dispatch({type: GET_FEATURED_SUCCESS, payload: res,department})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_FEATURED_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function getProductFilters(data, callback) {
  return dispatch => {
    dispatch({type: GET_PRODUCT_FILTERS_REQUEST})
    return getFilters(data).then(res => {
      dispatch({type: GET_PRODUCT_FILTERS_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_PRODUCT_FILTERS_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function getProductSearchFilters(data, callback) {
  return dispatch => {
    dispatch({type: GET_PRODUCT_SEARCH_FILTERS_REQUEST})
    return getSearchFilters(data).then(res => {
      dispatch({type: GET_PRODUCT_SEARCH_FILTERS_SUCCESS, payload: res})
      if(callback){
        callback({status:true,data:res})
      }
    }).catch(err => {
      dispatch({type: GET_PRODUCT_SEARCH_FILTERS_FAILURE, payload: err});
      if(callback){
        callback({status:false,data:err})
      }
    });
  };
}

export function setSimilarProducts(params) {

console.log("SIMILAR_PRODUCT_PARAMS", params);
  let similarProductOptions = {};
  if(params && params.category) similarProductOptions.category = params.category;
  else if(params && params.department) similarProductOptions.department = params.department;
  let similarProducts = ProductHelpers.getSimilarProducts(similarProductOptions);
  console.log("SIMILAR_PRODUCTS", similarProducts);

  return {
    type: 'SET_SIMILAR_PEODUCTS',
    payload: similarProducts
  }
}

export function setListPageState(data) {

  return {
    type: SET_LIST_PAGE_STATE,
    payload: data
  }
}

export function setSearchResultListPageState(data) {
  return {
    type: SET_SEARCH_RESULT_LIST_PAGE_STATE,
    payload: data
  }
}



// WEBPACK FOOTER //
// ./src/actions/productsActions.js